// extracted by mini-css-extract-plugin
export var navLink = "global-navigation-modules--navLink--2VtNx";